import { render, staticRenderFns } from "./Salon.vue?vue&type=template&id=567b0eb2&scoped=true&"
import script from "./Salon.vue?vue&type=script&lang=js&"
export * from "./Salon.vue?vue&type=script&lang=js&"
import style0 from "./Salon.vue?vue&type=style&index=0&id=567b0eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b0eb2",
  null
  
)

export default component.exports